import { FiltersModel } from '../../store/models';
import { AddressManagementFilterName } from '../../store/state/address/constants';
import { CompartmentDockStructure, TimeFrame } from '../constants';

export function getFiltersCount(filterFormValue: FiltersModel): number {
  const filtersValue = filterFormValue;

  if (!!filtersValue) {
    // TODO: specify type
    //eslint-disable-next-line @typescript-eslint/typedef
    return Object.entries(filtersValue).filter(([key, value]) => {
      if (key === CompartmentDockStructure && value && value.compartments) {
        return value.compartments.length > 0;
      }
      if (key === AddressManagementFilterName.CreationDate) {
        return value && value.start && value.end;
      }
      if (Array.isArray(value)) {
        return value.length > 0;
      } else {
        return key !== TimeFrame && value !== null && value !== undefined && value !== false && value.length !== 0;
      }
    }).length;
  }
  return 0;
}
